"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendar = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M8 10V8H6v3h12V8h-2v2h-2V8h-4v2H8zm10 3H6v5h12v-5zM6 6h2V4h2v2h4V4h2v2h4v14H4V6h2z" } }];
exports.iconName = 'calendar';
exports.calendar = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
